"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vuex = require("vuex");
var _filters = require("@/filters");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var coupon = [{
  money: '450',
  minPrice: 299,
  name: '全店通用',
  day: '10'
}, {
  money: '450',
  minPrice: 299,
  name: '指定商品',
  day: '10'
}, {
  money: '450',
  minPrice: 299,
  name: '指定商品',
  day: '10'
}];
var _default = exports.default = {
  name: 'member_coupon',
  cname: '会员优惠券',
  icon: 't-icon-huiyuan-youhuiquan',
  configName: 'c_member_coupon',
  type: 2,
  // 0 基础组件 1 营销组件 2工具组件
  defaultName: 'memberCoupon',
  // 外面匹配名称
  props: {
    index: {
      type: null
    },
    num: {
      type: null
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, (0, _vuex.mapState)('mobildConfig', ['defaultArray'])), (0, _vuex.mapGetters)(['mediaDomain', 'mobileTheme'])), {}, {
    bgColor: function bgColor() {
      return this.configObj.bgColor.color[0].item;
    },
    //最外层盒子的样式
    boxStyle: function boxStyle() {
      return [{
        'border-radius': this.configObj.bgStyle.val ? this.configObj.bgStyle.val + 'px' : '0'
      }, {
        background: this.bgColor
      }, {
        margin: this.configObj.mbConfig.val + 'px' + ' ' + this.configObj.lrConfig.val + 'px' + ' ' + 0
      }, {
        padding: this.configObj.upConfig.val + 'px' + ' ' + '10px' + ' ' + this.configObj.downConfig.val + 'px'
      }];
    },
    //内容边距
    contentConfig: function contentConfig() {
      return this.configObj.contentConfig.val ? this.configObj.contentConfig.val + 'px' : '0';
    },
    scopeColor: function scopeColor() {
      return [{
        color: this.configObj.scopeColor.color[0].item
      }];
    },
    titleColor: function titleColor() {
      return [{
        color: this.configObj.titleColor.color[0].item
      }];
    },
    labelColor: function labelColor() {
      return this.configObj.labelColor.color[0].item;
    },
    moreColor: function moreColor() {
      return [{
        color: this.configObj.moreColor.color[0].item
      }];
    },
    //优惠金额颜色
    priceColorStyle: function priceColorStyle() {
      return this.themeStyle ? this.configObj.priceColor.color[0].item : this.themeColor;
    },
    couponBgColor: function couponBgColor() {
      return this.configObj.couponBgColor.color[0].item;
    },
    // 优惠券
    couponListStyle: function couponListStyle() {
      return [{
        marginBottom: this.configObj.contentConfig.val + 'px'
      }, {
        backgroundColor: this.themeStyle ? this.couponBgColor : this.themeRgba
      },
      // 默认淡橙色背景
      {
        borderRadius: this.configObj.contentStyle.val + 'px'
      }];
    },
    //领取按钮
    btnColorStyle: function btnColorStyle() {
      return [{
        background: this.themeStyle ? "linear-gradient(90deg,".concat(this.configObj.btnColor.color[0].item, ", ").concat(this.configObj.btnColor.color[1].item, ")") : "linear-gradient(".concat(this.linearGradient, ")"),
        color: this.configObj.btnBgColor.color[0].item
      }];
    }
  }),
  watch: {
    pageData: {
      handler: function handler(nVal, oVal) {
        this.setConfig(nVal);
      },
      deep: true
    },
    num: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[nVal];
        this.setConfig(data);
      },
      deep: true
    },
    defaultArray: {
      handler: function handler(nVal, oVal) {
        var data = this.$store.state.mobildConfig.defaultArray[this.num];
        this.setConfig(data);
      },
      deep: true
    },
    themeStyle: {
      handler: function handler(nVal, oVal) {
        if (this.listStyle === 1) {
          this.configObj.deadlineColor.isShow = 0;
          this.configObj.btnColor.isShow = 0;
          this.configObj.btnBgColor.isShow = 0;
          this.configObj.labelColor.isShow = 0;
        } else {
          this.configObj.btnBgColor.isShow = this.configObj.themeStyleConfig.tabVal;
          this.configObj.btnColor.isShow = this.configObj.themeStyleConfig.tabVal;
          this.configObj.deadlineColor.isShow = 1;
          this.configObj.labelColor.isShow = 0;
        }
        this.configObj.couponBgColor.isShow = this.configObj.themeStyleConfig.tabVal;
        this.configObj.priceColor.isShow = this.configObj.themeStyleConfig.tabVal;
      },
      deep: true
    },
    listStyle: function listStyle(nVal, oVal) {
      if (nVal === 0) {
        this.configObj.deadlineColor.isShow = 1;
        this.configObj.btnColor.isShow = 0;
        this.configObj.btnBgColor.isShow = 0;
        this.configObj.labelColor.isShow = 0;
      } else {
        this.configObj.deadlineColor.isShow = 0;
        this.configObj.btnColor.isShow = 0;
        this.configObj.btnBgColor.isShow = 0;
        this.configObj.labelColor.isShow = 0;
      }
    },
    couponData: function couponData(nVal, oVal) {
      if (nVal.length) {
        return this.couponList = nVal;
      } else {
        return this.couponList = [].concat(coupon);
      }
    }
  },
  data: function data() {
    return {
      couponData: [],
      lightColor: '',
      couponList: [].concat(coupon),
      defaultConfig: {
        name: 'memberCoupon',
        timestamp: this.num,
        setUp: {
          tabVal: 0,
          cname: '会员优惠券'
        },
        tabConfig: {
          title: '展示样式',
          tabTitle: '头部设置',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '样式1'
          }, {
            val: '样式2'
          }]
        },
        titleConfig: {
          title: '标题',
          place: '请输入标题',
          isShow: 1,
          max: 20,
          val: '会员专享'
        },
        couponConfig: {
          title: '会员专享礼包',
          btnTitle: '添加优惠券',
          list: [],
          ids: '',
          type: 'coupon'
        },
        titleColor: {
          isShow: 1,
          title: '标题颜色',
          tabTitle: '布局设置',
          color: [{
            item: '#333'
          }],
          default: [{
            item: '#333'
          }]
        },
        moreColor: {
          isShow: 1,
          title: '更多颜色',
          color: [{
            item: '#999'
          }],
          default: [{
            item: '#999'
          }]
        },
        couponBgColor: {
          isShow: 0,
          title: '优惠券背景',
          color: [{
            item: 'rgba(233, 51, 35, 0.05)'
          }],
          default: [{
            item: 'rgba(233, 51, 35, 0.05)'
          }]
        },
        priceColor: {
          title: '优惠金额',
          isShow: 0,
          color: [{
            item: '#E93323'
          }],
          default: [{
            item: '#E93323'
          }]
        },
        labelColor: {
          title: '会员标签',
          isShow: 0,
          color: [{
            item: '#FFDFDC'
          }],
          default: [{
            item: '#FFDFDC'
          }]
        },
        scopeColor: {
          tabTitle: '优惠券设置',
          title: '使用范围',
          isShow: 1,
          color: [{
            item: '#333'
          }],
          default: [{
            item: '#333'
          }]
        },
        deadlineColor: {
          title: '使用期限',
          isShow: 1,
          color: [{
            item: '#999'
          }],
          default: [{
            item: '#999'
          }]
        },
        btnBgColor: {
          title: '按钮文字',
          isShow: 0,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        btnColor: {
          isShow: 0,
          title: '按钮背景',
          color: [{
            item: '#FF7931'
          }, {
            item: '#E93323'
          }],
          default: [{
            item: '#FF7931'
          }, {
            item: '#E93323'
          }]
        },
        // 背景颜色
        bgColor: {
          tabTitle: '样式设置',
          title: '组件背景',
          isShow: 1,
          color: [{
            item: '#FFFFFF'
          }],
          default: [{
            item: '#FFFFFF'
          }]
        },
        //色调
        themeStyleConfig: {
          title: '色调',
          tabVal: 0,
          isShow: 1,
          list: [{
            val: '跟随主题风格'
          }, {
            val: '自定义'
          }]
        },
        bgStyle: {
          tabTitle: '圆角设置',
          title: '背景圆角',
          name: 'bgStyle',
          val: 10,
          min: 0,
          max: 30
        },
        contentStyle: {
          title: '内容圆角',
          name: 'contentStyle',
          val: 7,
          min: 0,
          max: 30
        },
        // 上间距
        upConfig: {
          tabTitle: '边距设置',
          title: '上边距',
          val: 10,
          min: 0,
          max: 100
        },
        // 下间距
        downConfig: {
          title: '下边距',
          val: 10,
          min: 0
        },
        // 左右间距
        lrConfig: {
          title: '左右边距',
          val: 12,
          min: 0,
          max: 25
        },
        contentConfig: {
          title: '内容间距',
          val: 10,
          min: 0,
          max: 30
        },
        mbConfig: {
          title: '页面间距',
          val: 10,
          min: 0
        }
      },
      configObj: null,
      listStyle: 0,
      themeStyle: 0,
      themeColor: '',
      linearGradient: '',
      themeRgba: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$nextTick(function () {
      var pageData = _this.$store.state.mobildConfig.defaultArray[_this.num];
      _this.setConfig(pageData);
    });
  },
  methods: {
    setConfig: function setConfig(data) {
      if (!data) return;
      if (data) {
        this.configObj = data;
        this.listStyle = this.configObj.tabConfig.tabVal;
        this.themeStyle = data.themeStyleConfig.tabVal;
        this.themeColor = this.$options.filters.filterTheme(this.mobileTheme - 1); //主题色
        this.linearGradient = this.$options.filters.filterLinearGradient(this.mobileTheme - 1); //渐变色
        this.themeRgba = this.$options.filters.filterThemeRgba(this.mobileTheme - 1); //主题rgba
        this.lightColor = this.$options.filters.filterLightColor(this.mobileTheme - 1); //主题色淡色
        this.couponData = this.configObj.couponConfig.list;
      }
    }
  }
};